import FingoMuiFormControlLabel, { cessionTypeFormControlLabelStyles } from '../../fingo/components/MuiFormControlLabel';
import CESSION_TYPE_FORM_CONTROL_LABEL_CLASS_NAME from '../../constants/form-control-label';

const MuiFormControlLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiFormControlLabel.styleOverrides.root({ theme }),
      [`&.${CESSION_TYPE_FORM_CONTROL_LABEL_CLASS_NAME}`]: cessionTypeFormControlLabelStyles({ theme, checkedColor: theme.palette.secondary.A400 }),
    }),
  },
};

export default MuiFormControlLabel;
